module.exports = __webpack_public_path__ + "static/media/border-bottom.6e2a0876.svg";